<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'pb-8' : ''">
    <GreenCard />
    <div style="border: 1px solid #eaeaea" class="mt-4 rounded-lg">
      <v-row class="px-6 pt-6" no-gutters>
        <span class="checkout-h3 accent--text"
          >{{ $t("finished.summaryOrder") }}{{ eventId }} -
          {{ orderDetails ? orderDetails.codigo : "" }}</span
        >
      </v-row>
      <v-row
        v-if="paymentOption !== 'INVOICE'"
        class="px-6"
        no-gutters
        align="center"
      >
        <v-card class="mr-6" width="24" height="24" flat elevation="0">
          <v-img
            class="mt-2"
            flat
            src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/Money.svg"
            contain
          ></v-img>
        </v-card>
        <v-col>
          <Billet v-if="paymentOption === 'BB'" />
          <Card v-else-if="paymentOption === 'CC'" />
          <Pix v-else-if="paymentOption === 'PIX'" />
          <coutersy v-else-if="paidValue === 0" />
        </v-col>
      </v-row>

      <div
        v-if="
          finalDetails?.orderData?.status === 'A' ||
          finalDetails?.orderData?.forma_pagamento === 'MP'
        "
      >
        <v-divider class="my-6"></v-divider>
        <v-row v-if="showAccessLiveEvent" class="px-6" no-gutters>
          <v-btn
            block
            rounded
            depressed
            color="primary"
            dark
            target="_blank"
            :href="onlineEventUrl"
            >{{ $t("finished.accessEvent") }}</v-btn
          >
        </v-row>
        <v-row v-else class="px-6" no-gutters align="center">
          <v-card class="mr-6" width="23" height="23" flat elevation="0">
            <v-img
              flat
              class="mt-1"
              src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/Ticket.svg"
              contain
            ></v-img>
          </v-card>

          <Delivery :itsPartialPayment="itsPartialPayment" />
        </v-row>
      </div>

      <v-divider class="my-6"></v-divider>
      <v-row class="px-6 pb-6" no-gutters>
        <OrganizerDetails />
      </v-row>
      <v-divider
        v-if="
          eventDetails?.mensagem_conclusao_pedido &&
          orderStatus !== 'in_process' &&
          !isWaitingApproval
        "
        class="mt-6"
      ></v-divider>
      <OrganizerMessage
        v-if="
          eventDetails?.mensagem_conclusao_pedido &&
          orderStatus !== 'in_process' &&
          !isWaitingApproval
        "
        :message="eventDetails?.mensagem_conclusao_pedido"
      />
    </div>
  </div>
</template>

<script>
import GreenCard from "./GreenCard.vue";
import Billet from "./finalTypes/Billet.vue";
import { mapGetters } from "vuex";
import OrganizerDetails from "./OrganizerDetails.vue";
import Card from "./finalTypes/Card.vue";
import Delivery from "./Delivery.vue";
import Pix from "./finalTypes/Pix.vue";
import OrganizerMessage from "./OrganizerMessage.vue";
import Coutersy from "./finalTypes/Coutersy.vue";
export default {
  components: {
    GreenCard,
    Billet,
    OrganizerDetails,
    Card,
    Delivery,
    Pix,
    OrganizerMessage,
    Coutersy,
  },
  computed: {
    ...mapGetters([
      "orderDetails",
      "paymentOption",
      "finalDetails",
      "eventDetails",
      "buyer",
      "partialPayment",
      "productsTotal",
      "pendingOrder",
      "eventId",
    ]),

    paidValue() {
      if (this.partialPayment) return this.partialPayment;
      else if (this.$route.query.order_hash)
        return this.orderDetails?.valor_pendente;
      return this.productsTotal;
    },

    showAccessLiveEvent() {
      let isEventOnline =
        this.eventDetails.stream_plataforma &&
        this.eventDetails.tipo_local &&
        this.eventDetails.stream_plataforma === "blueticket" &&
        this.eventDetails.tipo_local === "online" &&
        this.eventDetails.config_online &&
        this.eventDetails.config_online.liberar_ambiente_online;
      if (
        isEventOnline &&
        this.orderDetails.ingressos.length === 1 &&
        this.orderDetails.ingressos[0]
      ) {
        const namedTicket = this.orderDetails.ingressos[0].dados_extras;
        const nome = namedTicket.find((n) => n.tipo === "nome");
        const email = namedTicket.find((n) => n.tipo === "email");
        if (nome && email && nome.valor && email.valor) return true;
        else return false;
      } else return false;
    },

    itsPartialPayment() {
      if (this.partialPayment && this.partialPayment < this.productsTotal)
        return this.productsTotal - Number(this.partialPayment);
      return 0;
    },

    onlineEventUrl() {
      const email = this.buyer.customer_email;
      const ticket = this.orderDetails.ingressos[0].codigo;
      switch (process.env.VUE_APP_ENV) {
        case "development":
          return `http://live.dev.btservers.com.br/event-${this.eventID}/login?e=${email}&i=${ticket}`;
        case "homologation":
          return `http://live.homolog.btservers.com.br/event-${this.eventID}/login?e=${email}&i=${ticket}`;
        default:
          return `http://live.blueticket.com.br/event-${this.eventID}/login?e=${email}&i=${ticket}`;
      }
    },

    isWaitingApproval() {
      return (
        this.finalDetails?.orderStatus === "W" ||
        this.finalDetails?.orderData?.status === "W"
      );
    },

    orderStatus() {
      if (this.finalDetails) {
        return this.finalDetails.status;
      }

      return "paid";
    },
  },
};
</script>
